import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="action-dropdown"
export default class extends Controller {
  static targets = ["trigger", "menu"];

  connect() {
    this.closeOnOutside = this.closeOnOutside.bind(this);
    this.closeOnEscape = this.closeOnEscape.bind(this);
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutside);
    document.removeEventListener("keydown", this.closeOnEscape);
  }

  toggle(event) {
    event.stopPropagation();
    const isOpen = this.element.classList.toggle("is-open");
    this.triggerTarget.setAttribute("aria-expanded", String(isOpen));

    if (isOpen) {
      document.addEventListener("click", this.closeOnOutside);
      document.addEventListener("keydown", this.closeOnEscape);
    } else {
      document.removeEventListener("click", this.closeOnOutside);
      document.removeEventListener("keydown", this.closeOnEscape);
    }
  }

  closeOnOutside(event) {
    if (this.element.contains(event.target)) return;
    this.close();
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close();
  }

  close() {
    this.element.classList.remove("is-open");
    this.triggerTarget.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this.closeOnOutside);
    document.removeEventListener("keydown", this.closeOnEscape);
  }
}
